import { getPrimaryTracker, setPrimaryTracker } from 'usage-tracker-container';
import { createUsageTracker } from 'pricing-pages-ui/v2/utils/tracking/_UsageTracker';
export function setupEventTracker() {
  setPrimaryTracker(createUsageTracker());

  // Required default event properties needs to be set here if we want event tracking on App level - otherwise, it will be undefined and cause usage-tracker-js event error. Properties should not include data from non-blocking fetches as it may not be available when this is called.
  getPrimaryTracker().setProperties({
    isBillingAdmin: false,
    inAppOrPublic: 'public',
    isDotComAuthedRedirect: false
  });
}